import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OtpService {

  // private snsurl = "http://52.66.104.168:3060/token"; 
  private snsurl = environment.snsurl;

  constructor(private http: HttpClient) { }

  SendSMS(uid) {
    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    };
    return this.http.get<any>(this.snsurl + '/' + uid, options).pipe(map(response => {
    //  console.log(this.snsurl + '/' + userid+'/' + trip);
    // return this.http.get<any>(this.snsurl + '/' + userid+'/' + trip, options).pipe(map(response => {
        console.log("************",response);

        return response;
    }));
  }






}
